import { CheckCircle, ShoppingBag, Star, XCircle } from 'lucide-react';

const StatsTab = ({ customer }) => {
  const stats = customer?.stats || {};

  return (
    <>
      {/* Booking Statistics */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <ShoppingBag className='mr-2' size={20} />
          Booking Statistics
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
          <div className='text-center p-4 bg-accent/50 rounded-lg'>
            <ShoppingBag className='mx-auto mb-2 text-primary' size={32} />
            <p className='text-2xl font-bold text-foreground'>
              {stats.totalBookings || 0}
            </p>
            <p className='text-xs text-muted-foreground mt-1'>Total Bookings</p>
          </div>
          <div className='text-center p-4 bg-accent/50 rounded-lg'>
            <CheckCircle className='mx-auto mb-2 text-green-600' size={32} />
            <p className='text-2xl font-bold text-foreground'>
              {stats.completedBookings || 0}
            </p>
            <p className='text-xs text-muted-foreground mt-1'>Completed</p>
          </div>
          <div className='text-center p-4 bg-accent/50 rounded-lg'>
            <XCircle className='mx-auto mb-2 text-red-600' size={32} />
            <p className='text-2xl font-bold text-foreground'>
              {stats.cancelledBookings || 0}
            </p>
            <p className='text-xs text-muted-foreground mt-1'>Cancelled</p>
          </div>
          <div className='text-center p-4 bg-accent/50 rounded-lg'>
            <Star className='mx-auto mb-2 text-yellow-600' size={32} />
            <p className='text-2xl font-bold text-foreground'>
              {stats.averageRating ? stats.averageRating.toFixed(1) : '0.0'}
            </p>
            <p className='text-xs text-muted-foreground mt-1'>Average Rating</p>
          </div>
        </div>
      </div>

      {/* Financial Statistics */}
      {/* <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <DollarSign className='mr-2' size={20} />
          Financial Statistics
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
          <div className='text-center p-6 bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg'>
            <DollarSign className='mx-auto mb-2 text-primary' size={40} />
            <p className='text-3xl font-bold text-primary'>₹{stats.totalSpent?.toLocaleString() || 0}</p>
            <p className='text-sm text-muted-foreground mt-2'>Total Spent</p>
          </div>
          <div className='text-center p-6 bg-gradient-to-br from-green-500/10 to-green-500/5 rounded-lg'>
            <DollarSign className='mx-auto mb-2 text-green-600' size={40} />
            <p className='text-3xl font-bold text-green-600'>
              ₹{stats.totalBookings > 0 ? ((stats.totalSpent || 0) / stats.totalBookings).toFixed(2) : 0}
            </p>
            <p className='text-sm text-muted-foreground mt-2'>Average Order Value</p>
          </div>
        </div>
      </div> */}

      {/* Performance Metrics */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4'>Performance Metrics</h2>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
          <div>
            <label className='text-xs text-muted-foreground'>
              Completion Rate
            </label>
            <div className='mt-2'>
              <div className='flex items-center justify-between mb-1'>
                <span className='text-sm font-medium'>
                  {stats.totalBookings > 0
                    ? (
                        (stats.completedBookings / stats.totalBookings) *
                        100
                      ).toFixed(1)
                    : 0}
                  %
                </span>
              </div>
              <div className='w-full bg-muted rounded-full h-2'>
                <div
                  className='bg-green-600 h-2 rounded-full transition-all'
                  style={{
                    width: `${
                      stats.totalBookings > 0
                        ? (
                            (stats.completedBookings / stats.totalBookings) *
                            100
                          ).toFixed(1)
                        : 0
                    }%`,
                  }}
                ></div>
              </div>
            </div>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>
              Cancellation Rate
            </label>
            <div className='mt-2'>
              <div className='flex items-center justify-between mb-1'>
                <span className='text-sm font-medium'>
                  {stats.totalBookings > 0
                    ? (
                        (stats.cancelledBookings / stats.totalBookings) *
                        100
                      ).toFixed(1)
                    : 0}
                  %
                </span>
              </div>
              <div className='w-full bg-muted rounded-full h-2'>
                <div
                  className='bg-red-600 h-2 rounded-full transition-all'
                  style={{
                    width: `${
                      stats.totalBookings > 0
                        ? (
                            (stats.cancelledBookings / stats.totalBookings) *
                            100
                          ).toFixed(1)
                        : 0
                    }%`,
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatsTab;
